<template lang="pug">
  #TrialProgramIndex
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
      h5.mb-0 試用計畫
    .container-width
      b-row.no-gutters.px-3.pt-3(
        style="border-bottom: 0.2rem solid #000;"
      )
        b-col.px-2(
          cols=6
        )
          b-button(
            block,
            :variant=" nowSelectItem === '顧客列表' ? 'primary' : 'gray-light-3 text-black' ",
            @click="changeTypeHandler('顧客列表')",
            style="border-radius: .8rem .8rem 0 0;font-weight: bold;"
          ) 顧客列表
        b-col.px-2(
          cols=6
        )
          b-button(
            block,
            :variant=" nowSelectItem === '符合申請資格' ? 'primary' : 'gray-light-3 text-black' ",
            @click="changeTypeHandler('符合申請資格')",
            style="border-radius: .8rem .8rem 0 0;font-weight: bold;"
          ) 符合申請資格
      .customerInfo.mb-3.h-100(
        v-if="nowSelectItem === '顧客列表'"
      )
        .p-3
          i.fas.fa-users.mb-3.pr-1
          span.text-danger.pr-1.font-weight-bold {{ pagination.total }}
          | 位
          b-card.border-0.mb-1.customerCard.overflow-hidden(
            bg-variant="white",
            v-for="(user,index) in memberList",
            :key="user.member_id",
            @click="showUserInfoHandler(user.member_id, user.is_new_tag)",
            body-class="p-0"
          )
            .row
              .col-2.d-flex.align-items-center.justify-content-center(
                v-show="selectMode"
              )
                b-form-checkbox(
                  :id="`checkbox-group-${index}`",
                  v-model="selectUsers",
                  :name="`user-${index}`",
                  :value="user",
                  v-show="selectMode"
                )
              div(
                :class="{ 'col-10': selectMode, 'col-12': !selectMode }"
              )
                label.w-100.mb-0(
                  :for="`checkbox-group-${index}`"
                )
                  .row.align-items-center.mb-2.pb-2.no-gutters(
                    :class="{ 'border-bottom border-black': index + 1 !== memberList.length }"
                  )
                    .col-3.pr-1
                      ProfilePhotoSticker.ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                        :profileUrl="user.picture_url",
                        :style="{ 'width': '60px', 'height': '60px' }"
                      )
                    .col-9.pl-1
                      p.mb-0.font-weight-bold {{ user.line_display_name }} 
                        span.text-danger(
                          v-if="user.is_new_tag"
                        ) (New)
                      p.mb-0.text-gray {{ lastTake(user.last_take_date) }}
                      p.mb-0.text-gray {{ user.card_type ? user.card_type : '-' }}
        infinite-loading(
          @infinite="($state)=>infiniteHandler($state, '顧客列表')",
          :identifier="infiniteId",
          spinner="bubbles"
        )
          .cursor-default(slot="no-more") 無更多資料
          .cursor-default(slot="no-results") 無更多資料
          .cursor-default(slot="error") 發生錯誤，請重整重試一次
      .customerInfo.mb-3.h-100(
        v-if="nowSelectItem === '符合申請資格'"
      )
        .p-3
          i.fas.fa-users.mb-3.pr-1
          span.text-danger.pr-1.font-weight-bold {{ pagination.total }}
          | 位
          b-card.border-0.mb-1.customerCard.overflow-hidden(
            bg-variant="white",
            v-for="(user,index) in availableList",
            :key="user.member_id",
            @click="showUserInfoHandler(user.member_id, user.is_new_tag)",
            body-class="p-0"
          )
            .row
              .col-2.d-flex.align-items-center.justify-content-center(
                v-show="selectMode"
              )
                b-form-checkbox(
                  :id="`checkbox-group-${index}`",
                  v-model="selectUsers",
                  :name="`user-${index}`",
                  :value="user",
                  v-show="selectMode"
                )
              div(
                :class="{ 'col-10': selectMode, 'col-12': !selectMode }"
              )
                label.w-100.mb-0(
                  :for="`checkbox-group-${index}`"
                )
                  .row.align-items-center.mb-2.pb-2.no-gutters(
                    :class="{ 'border-bottom border-black': index + 1 !== memberList.length }"
                  )
                    .col-3.pr-1
                      ProfilePhotoSticker.ProfilePhotoSticker.d-flex.align-items-center.justify-content-center.border.border-black(
                        :profileUrl="user.picture_url",
                        :style="{ 'width': '60px', 'height': '60px' }"
                      )
                    .col-9.pl-1
                      p.mb-0.font-weight-bold {{ user.line_display_name }}
                      p.mb-0.text-gray {{ user.note_name ? user.note_name : '-' }}
                      p.mb-0.text-gray {{ user.card_type ? user.card_type : '-' }}
        infinite-loading(
          @infinite="infiniteHandler",
          :identifier="infiniteId",
          spinner="bubbles"
        )
          .cursor-default(slot="no-more") 無更多資料
          .cursor-default(slot="no-results") 無更多資料
          .cursor-default(slot="error") 發生錯誤，請重整重試一次
</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import { SA_MY_CUSTOMER_INDEX } from '@/router/sa/my-customer';
import InfiniteLoading from 'vue-infinite-loading';

export default {
  name: 'TrialProgramIndex',
  components: {
    ProfilePhotoSticker,
    InfiniteLoading
  },
  data() {
    return {
      searchInput: {
        chinese_last_name: null,
        code: null,
        card_type: null,
        birthday: null
      },
      selectMode: false,
      selectUsers: [],
      infiniteId: +new Date(),
      nowSelectItem:'顧客列表'
    };
  },
  created() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    vm.$store.commit('sa_trial_program/resetHandler');
  },
  methods: {
    infiniteHandler($state) {
      const vm = this;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      const type = {'顧客列表': vm.getMemberListHandler,'符合申請資格':  vm.getAvailableListHandler};
      const apuFunc = type[vm.nowSelectItem];
        if(apuFunc){
        apuFunc().then(() => {
            if (vm.pagination.current_page !== vm.pagination.total_page) {
              $state.loaded();
            } else {
              $state.complete();
            }
            vm.$swal.close();
          });
        }
    },
    lastTake(date) {
      if(date.length === 0) {
        return '-'
      }
      let lastDate =  date.split(' ')[0].replaceAll('-','/')
      return `已於${lastDate}完成領取`
    },
    getMemberListHandler() {
      return this.$store.dispatch('sa_trial_program/getMemberListHandler', {
        current_page: parseInt(this.pagination.current_page) + 1,
        per_page: this.pagination.per_page,
      })
    },
    getAvailableListHandler() {
      return this.$store.dispatch('sa_trial_program/getAvailableListHandler', {
        current_page: parseInt(this.pagination.current_page) + 1,
        per_page: this.pagination.per_page,
      })
    },
    changeTypeHandler(type) {
      const vm = this;
      switch (type) {
        case '顧客列表':
          vm.selectedType('顧客列表');
          break;
        case '符合申請資格':
          vm.selectedType('符合申請資格');
          break;
        default:
          break;
      }
    },
    selectedType(selected) {
      const vm = this;
      const selectType = {'顧客列表': vm.getMemberListHandler,'符合申請資格':  vm.getAvailableListHandler};
      const getFunc = selectType[selected];
      if( vm.nowSelectItem ===  selected) return;
      vm.nowSelectItem = selected;
      vm.$store.commit('sa_trial_program/resetHandler');

      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      if(getFunc) {
        getFunc().then(() => {
          vm.$swal.close();
        })
      }

    },
    showUserInfoHandler(userId, isTag) {
      const vm = this;
      if (vm.selectMode) return;
      if(isTag) {
        vm.$store.dispatch('sa_trial_program/removeNewTagHandler', userId);
      }
      vm.$router.push({
        name: SA_MY_CUSTOMER_INDEX,
        params: {
          userId,
          activity: 'trial_program'
        }
      }).catch(() => {});
    }
  },
  computed: {
    ...mapState({
      memberList: (state) => state.sa_trial_program.memberList,
      availableList: (state) => state.sa_trial_program.availableList,
      pagination: (state) => state.sa_trial_program.pagination
    })
  },
  beforeRouteLeave(to, from, next) {
    const vm = this;
    vm.$store.commit('sa_trial_program/resetHandler');
    next();
  }
};
</script>

<style lang="scss" scoped>
.searchArea {
  &__iconArrow {
    position: absolute;
    right: 10px;
    top: 5px;
    outline: none;
    transform: rotate(0deg);
    transition: all .3s;
  }
  &__iconArrow.collapsed {
    transform: rotate(180deg);
  }
}

.ProfilePhotoSticker {
  border: 0.2rem solid #000!important;
}
</style>
